(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["esavey-first-visit-popup"] && !Shopify.designMode) return;
  try {
    (()=>{const d=document.querySelector('[data-esv-welcome-popup]');if(!d)return;const k='esv_welcome10_popup_v3_dismissed_until',s='esv_welcome10_subscribed',now=Date.now();const get=x=>{try{return localStorage.getItem(x)}catch{return null}},set=(x,v)=>{try{localStorage.setItem(x,v)}catch{}};if(get(s)==='1'||Number(get(k)||0)>now)return;let opened=false;const open=()=>{if(opened)return;opened=true;if(typeof d.showModal==='function')d.showModal();else d.setAttribute('open','');d.querySelector('input[type=email]')?.focus()},close=()=>{set(k,String(Date.now()+12096e5));if(typeof d.close==='function')d.close();else d.removeAttribute('open')};const onScroll=()=>{if(window.scrollY>Math.max(160,document.documentElement.scrollHeight*.12)){window.removeEventListener('scroll',onScroll);open()}};window.addEventListener('scroll',onScroll,{passive:true});setTimeout(open,2500);d.querySelector('[data-esv-popup-close]')?.addEventListener('click',close);d.addEventListener('cancel',e=>{e.preventDefault();close()});d.addEventListener('click',e=>{if(e.target===d)close()});if(d.querySelector('[data-esv-popup-success]')){set(s,'1');open()}})();
  } catch(e) { console.error(e); }
})();

})();
